import React, { useState } from "react";
import LocationAction from "../Location/LocationAction";

const LocationMenu = ({ label, location1, position, noMargin, fadeup }) => {
  const [isActive, setIsActive] = useState(false);

  return (
    <div className="bs-location--menu">
      <LocationAction
        label={label}
        position={position}
        location1={location1}
        noMargin={noMargin}
        fadeup={fadeup}
        isActive={isActive}
        setIsActive={setIsActive}
      />
    </div>
  );
};

export default LocationMenu;
